import React, { useEffect } from "react";
import DashSplitContainer from "../DashSplitContainer";
import TrackingList from "./TrackingList";
import TrackingDetail from "./TrackingDetail";
import { useDashLayoutCtx } from "../DashLayoutCtxProvider";

function DashTracking() {
  const { setselTab, dashTabs } = useDashLayoutCtx();
  useEffect(() => {
    setselTab(dashTabs.find((item) => item.path === "tracking"));
    // eslint-disable-next-line
  }, []);
  return (
    <DashSplitContainer heading="Live Tracking">
      <TrackingList />
      <TrackingDetail />
    </DashSplitContainer>
  );
}

export default DashTracking;
